
export default {
  login: {
    title: 'Welcome',
    buttonGroup: {
      title: 'Login with',
      google: 'Login with Google',
      facebook: 'Login with Facebook',
    },
    form: {
      title: 'or use email',
      action: 'LOGIN',
      helper: 'forgot password?',
    },
    footer: {
      title: 'Don’t have an account?',
      action: 'Signup',
    },
  },
  signup: {
    title: 'Signup to Iterio',
    buttonGroup: {
      title: 'Signup with',
      google: 'Signup with Google',
      facebook: 'Signup with Facebook',
    },
    form: {
      title: 'or use email',
      action: 'SIGNUP',
    },
    footer: {
      title: 'Already have an account?',
      action: 'Login',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/login.js